module.exports = require("ember-testing");